import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { VersionsFilter } from '@usimweb/core/models';

// import * as fromStore from '../../../../core/store';

@Component({
    selector: 'usimweb-version-filter',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    standalone: false
})
export class VersionFilterComponent implements OnInit {
  @Output() toggleCompareChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() filter: EventEmitter<VersionsFilter> = new EventEmitter<VersionsFilter>();

  public filterStatus: string = '-';
  public filterLabel: string = '-';

  public seachControl = new UntypedFormControl();
  public filter$: Observable<string[]> = new Observable();

  constructor() {} //private store: Store<fromStore.DashboardState>

  ngOnInit(): void {
    this.seachControl.setValue('');
    // this.store.select(fromStore.getVersionsFiltered).subscribe((filter) => {
    //   // this.seachControl.setValue(filter.searchFilter);
    //   this.filterStatus = filter.statusFilter;
    //   this.filterLabel = filter.labelFilter;
    // });
  }

  private emitFilter() {
    const filter = {
      statusFilter: this.filterStatus,
      labelFilter: this.filterLabel,
      searchFilter: this.seachControl.getRawValue(),
    } as VersionsFilter;
    this.filter.emit(filter);
  }

  public searchChangedEvent() {
    this.emitFilter();
  }

  public filterStatusChangedEvent(status: string) {
    this.filterStatus = status;
    this.emitFilter();
  }

  public filterEnergyChangedEvent(label: string) {
    this.filterLabel = label;
    this.emitFilter();
  }

  public toggleCompare(value: boolean) {
    this.toggleCompareChange.emit(value);
  }

  public optionClicked(event: HTMLInputElement) {
    this.seachControl.setValue(event.value);
    this.emitFilter();
  }

  public clearInput() {
    this.seachControl.setValue('');
    this.emitFilter();
  }
}
